function checkTosAndChecklist() {
  const tos = Array.from(document.getElementsByName('question[tos]'))
  const checklist = Array.from(document.getElementsByName('question[checklist]'))
  const checkedTos = tos.filter(tos => tos.checked)[0]
  const checkedChecklist = checklist.filter(checklist => checklist.checked)[0]

  if (checkedTos && checkedChecklist) {
    setButtons('success')
  } else {
    setButtons('error')
  }
}

function setButtons(result) {
  const submitButton = document.getElementsByName('commit')[0]
  const backButton = document.getElementsByClassName('order-button-secondary')[0]

  if (result === 'success') {
    submitButton.setAttribute('aria-disabled', false)
    backButton.setAttribute('aria-disabled', true)
  } else {
    submitButton.setAttribute('aria-disabled', true)
    backButton.setAttribute('aria-disabled', false)
  }
}

function setAnswer(result) {
  const defaultMessageArea = document.getElementsByClassName('default')[0];
  const successMessageArea = document.getElementsByClassName('success')[0];
  const errorMessageArea = document.getElementsByClassName('error')[0];

  if (result === 'success') {
    defaultMessageArea.style.display = 'none';
    successMessageArea.style.display = 'block';
    errorMessageArea.style.display = 'none';

    const form = document.getElementById('js-tos-and-checklist-form')

    checkTosAndChecklist()
    form.addEventListener('change', () => {
      checkTosAndChecklist()
    })

  } else {
    defaultMessageArea.style.display = 'none';
    successMessageArea.style.display = 'none';
    errorMessageArea.style.display = 'block';

    setButtons(result)
  }
}

function checkAnswer() {
  const answers1 = Array.from(document.getElementsByName('question[answer1]'))
  const answers2 = Array.from(document.getElementsByName('question[answer2]'))
  const checkedAnswer1 = answers1.filter(answer1 => answer1.checked)[0]
  const checkedAnswer2 = answers2.filter(answer2 => answer2.checked)[0]

  if (checkedAnswer1 && checkedAnswer2) {
    if (checkedAnswer1.value === 'false' && checkedAnswer2.value === 'false') {
      setAnswer('success')
    } else {
      setAnswer('error')
    }
  }
}

window.addEventListener('load', () => {
  const form = document.getElementById('js-question-form')

  form.addEventListener('change', () => {
    checkAnswer()
  })
  checkAnswer()
})
